import './MyCommunities.scss'
import SearchBox from '../../core/SearchBox/SearchBox';
import MyCommunitiesProps from './MyCommunitiesProps';
import Community from '../../content/Communities/Community/Community';
import { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const MyCommunities = () => {
    const [searchInput, setSearchInput] = useState('');
    const [communities, setCommunities] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const { me } = useSelector((state: any) => state.auth);

    useEffect(() => {
        if (me?.userCommunities) {
            setCommunities(me.userCommunities)
            setFiltered(me.userCommunities)
        }
    }, [me?.userCommunities, setCommunities, setFiltered])


    const searchHandler = (event: any) => {
        setSearchInput(event.target.value)
        if (event.target.value.length > 0) {
            const _filtered = communities.filter((c: any) => c.name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1);
            setFiltered(_filtered);
        } else {
            setFiltered([...communities]);
        }
    }

    const renderCommunities = () => {
        return (
            <Fragment>
                <div className="mx-md-0 mb-4 px-md-0 px-3">
                    <div className="title">My Communities</div>
                </div>
                {
                    filtered.map((community: any, index: number) => (
                        <div key={index}>
                        {community.communityType !== 'system' ? 
                            <Community community={community} /> : null }
                        </div>
                    ))
                }
            </Fragment>
        )
    }

    return (
        <div className="my-communities container-fluid px-0">
            <div className="mx-md-0 mb-4 px-md-0 px-3">
                <SearchBox placeholder={'Search a community'} changeHandler={searchHandler} value={searchInput} />
            </div>
            {
                filtered && Array.isArray(filtered) && filtered.length > 0 ?
                    renderCommunities() :
                    <div className="mx-md-0 mb-4 px-md-0 px-3">No communities yet</div>
            }
        </div>
    )
}

export default MyCommunities;